<template>
    <b-modal id="multiCompanyLogin" ref="multiCompanyLogin" :class="isLogin ? '' : 'not-login'" centered hide-header hide-footer no-close-on-backdrop no-close-on-esc>
        <div v-if="isLogin == false" class="close-bar">
            <i @click="$emit('closeModal')" class="fa fa-close"></i>
        </div>
        <div class="header-bar">
            <h1>Select Company to login</h1>
            <button @click="logout()"><i class="fa fa-sign-out"></i> Logout</button>
        </div>
        <div class="siot-table-wrapper">
            <div class="siot-table-content">
                <div class="siot-table table-multi-company-login">
                    <table class="table b-table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Role</th>
                                <th>Login</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="comp of companiesList">
                                <td>{{comp.companyName}}</td>
                                <td v-if="comp.roleId == 1"><span class="role admin">Admin</span></td>
                                <td v-else-if="comp.roleId == 2"><span class="role provisioning">Provisioning</span></td>
                                <td v-else-if="comp.roleId == 3"><span class="role billing">Billing</span></td>
                                <td v-else-if="comp.roleId == 9"><span class="role company-owner">Customer Owner</span></td>
                                <td v-else-if="comp.roleId == 12"><span class="role provisioning">Provisioning reading</span></td>
                                <td v-else-if="comp.roleId == 13"><span class="role billing">Billing reading</span></td>
                                <td v-else>N/A</td>
                                <td><button class="login-btn" @click="loginToCompany(comp.companyId, comp.roleId, comp.companyName)">Login<i class="fa fa-sign-in"></i></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import Axios from 'axios'
    import globalStore from "../variables";
    import keycloak from "../main";
    import router from "../router";
    export default {
        name: "MultiCompanyLogin",
        data() {
            return {
                companiesList: [],
                companyId: $cookies.get('multiCompanyAccessId')
            }
        },
        props: {
            isLogin: Boolean
        },
        methods: {
            getCompanies() {
                Axios.get(globalStore.data.restApiUrl + '/associates/access/companies?companyId=' + this.companyId)
                    .then(response => {
                        this.companiesList = response.data
                        this.$cookies.set('userId', response.data[0].userId)
                    })
            },
            logout() {
                this.$cookies.remove('token')
                this.$cookies.remove('refreshToken')
                this.$cookies.remove('refreshFlag')
                this.$cookies.remove('lastActiviti')
                this.$cookies.remove('multiCompanyAccess')
                this.$cookies.remove('multiCompanyAccessId')
                this.$cookies.remove('isSA')
                this.$cookies.remove('tokenSetTime')
                this.$cookies.remove('userId')
                this.$cookies.remove('userLevelId')
                this.$cookies.remove('userEmail')
                this.$cookies.remove('userLevel')
                this.$cookies.remove('permissions')
                this.$cookies.remove('firstName')
                this.$cookies.remove('lastName')
                this.$cookies.remove('companyId')
                this.$cookies.remove('companyName')
                this.$cookies.remove('typeAccount')
                this.$cookies.remove('simonCarrierAvailable')
                this.$cookies.remove('tmobileCarrierAvailable')
                this.$cookies.remove('vodafoneCarrierAvailable')
                this.$cookies.remove('koreCarrierAvailable')
                this.$cookies.remove('nbIoTPlans')
                this.$cookies.remove('voiceAccess')
                this.$cookies.remove('tier2Roaming')
                this.$cookies.remove('catM1Plans')
                this.$cookies.remove('simonActiveReady')
                this.$cookies.remove('coldStockAccess')
                this.$cookies.remove('hotSpotAccess')
                this.$cookies.remove('acceptedAgreementId')
                if (this.isLogin) {
                    this.$emit('closeModal')
                } else {
                    if (this.$cookies.get('defaultLogin') == 'false') {
                        this.$cookies.remove('defaultLogin')
                        if (this.$cookies.get('token')) {
                            this.$cookies.remove('token')
                        } else {
                            this.$session.remove('token')
                        }
                        keycloak.logout()
                    } else {
                        this.$cookies.remove('defaultLogin')
                        router.push('/login')
                    }
                }
            },
            loginToCompany(companyId, roleId, compName) {
                this.$cookies.set('companyId', companyId)
                this.$cookies.set('userLevelId', roleId)
                let currentTime = Date.now();
                let roleName = null
                if (roleId == 1) {
                    roleName = 'Administrator'
                } else if (roleId == 2) {
                    roleName = 'Provisioning'
                } else if (roleId == 3) {
                    roleName = 'Billing'
                } else if (roleId == 9) {
                    roleName = 'Customer Owner'
                } else if (roleId == 13) {
                    roleName = 'Billing Reading'
                } else if (roleId == 12) {
                    roleName = 'Provisioning Reading'
                }
                Axios.get(globalStore.data.restApiUrl + '/account/users/current?companyId=' + companyId)
                    .then(response => {
                        this.$cookies.set('firstName', response.data.firstName)
                        this.$cookies.set('lastName', response.data.lastName)
                        this.$cookies.set('tokenSetTime', currentTime);
                        this.$cookies.set('permissions', response.data.permissions.join(','));
                        if (response.data.hasPendingInvitation) {
                            this.$cookies.set('hasPendingInvitation', true);
                        }
                        if (response.data.acceptedAgreementId != undefined) {
                            this.$cookies.set('acceptedAgreementId', response.data.acceptedAgreementId)
                        } else {
                            this.$cookies.set('acceptedAgreementId', false)
                        }

                        Axios.get(`${globalStore.data.restApiUrl}/account?companyId=${companyId}`)
                            .then(response => {
                                this.$cookies.set('typeAccount', response.data.wallet.mode);
                                this.$cookies.set('coldStockAccess', response.data.companyPermissions.indexOf('COLD_STOCK_ACCESS') > -1);
                                this.$cookies.set('tier2Roaming', response.data.companyPermissions.indexOf('TIER_2_INTERNATIONAL_ROAMING') > -1);
                                this.$cookies.set('voiceAccess', response.data.companyPermissions.indexOf('VOICE_ACCESS') > -1);
                                this.$cookies.set('hotSpotAccess', response.data.companyPermissions.indexOf('HOT_SPOT_PLANS_ACCESS') > -1);
                                this.$cookies.set('nbIoTPlans', response.data.companyPermissions.indexOf('NB_IOT_PLANS_ACCESS') > -1);
                                this.$cookies.set('catM1Plans', response.data.companyPermissions.indexOf('CAT_M1_PLANS_ACCESS') > -1);
                                this.$cookies.set('simonActiveReady', response.data.companyPermissions.indexOf('NETCRACKER_ACTIVE_READY') > -1);
                                this.$cookies.set('companyId', response.data.companyId);
                                if (response.data.displayedCarriers.indexOf(1) > -1) {
                                    this.$cookies.set('simonCarrierAvailable', true);
                                } else {
                                    this.$cookies.set('simonCarrierAvailable', false);
                                }
                                if (response.data.displayedCarriers.indexOf(2) > -1) {
                                    this.$cookies.set('tmobileCarrierAvailable', true);
                                } else {
                                    this.$cookies.set('tmobileCarrierAvailable', false);
                                }
                                if (response.data.displayedCarriers.indexOf(3) > -1) {
                                    this.$cookies.set('vodafoneCarrierAvailable', true);
                                } else {
                                    this.$cookies.set('vodafoneCarrierAvailable', false);
                                }
                                if (response.data.displayedCarriers.indexOf(4) > -1) {
                                    this.$cookies.set('koreCarrierAvailable', true);
                                } else {
                                    this.$cookies.set('koreCarrierAvailable', false);
                                }
                                this.$emit('updateSidebar');
                                if(response.data.wallet.mode == 'PREPAID') {
                                    this.$emit('refreshTopUpWidget');
                                }
                                if (this.isLogin) {
                                    this.$emit('closeModal')
                                    this.$router.push('/dashboard')
                                } else {
                                    if (this.$route.path == '/dashboard') {
                                        this.$router.go()
                                    } else {
                                        this.$router.push('/dashboard')
                                        this.$emit('closeModal')
                                        globalStore.data.EventBus.$emit('updateUserInHeader')
                                    }
                                }


                            }).catch(error => {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Getting data error',
                                text: 'Something was wrong with getting company details. Please contact with support.',
                                duration: 5000,
                            });
                            console.log(error)
                            return false
                        })
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Something was wrong with getting user details. Please contact with support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
                this.$cookies.set('userLevel', roleName)
                this.$cookies.set('companyName', compName)
            }
        },
        mounted() {
            this.getCompanies()
            this.$refs['multiCompanyLogin'].show()
        }
    }
</script>

<style lang="scss">
    #multiCompanyLogin___BV_modal_body_ {
        padding: 0;
        .close-bar {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 10px 10px 0 0;
            .fa-close {
                cursor: pointer;
            }
        }
        .header-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px;
            h1 {
                margin: 0;
                font-size: 15px;
            }
            button {
                padding: 6px 12px;
                border: 2px solid #DEDEDE;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                background-color: #F2F2F2;
                font-size: 14px;
                font-weight: 700;
                i {
                    margin: 0 10px 0 0;
                    font-size: 16px;
                }
            }
        }
        .table-multi-company-login {
            table {
                thead {
                    tr {
                        th {
                            &:nth-child(3) {
                                max-width: 125px;
                            }
                        }
                    }
                }
                tbody {
                    tr {
                        td {
                            &:nth-child(1) {
                                font-weight: 700;
                            }
                            &:nth-child(3) {
                                max-width: 125px;
                                text-align: right;
                            }
                        }
                    }
                }
            }
            .role {
                padding: 4px 16px;
                -webkit-border-radius: 12px;
                -moz-border-radius: 12px;
                border-radius: 12px;
                font-size: 12px;
                color: #fff;
                &.admin {
                    background-color: #fc4d4d;
                }
                &.billing {
                    background-color: #747fe2;
                }
                &.provisioning {
                    background-color: #c84dfc;
                }
                &.company-owner {
                    background-color: #000;
                }
            }
            .login-btn {
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                padding: 4px 20px;
                border: none;
                background-color: #00C4B0;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                color: #fff;
                font-weight: 700;
                i {
                    margin: 0 0 0 12px;
                }
            }
        }
    }
</style>
